import { Injectable, signal } from '@angular/core';

const LS_SIDEBAR_KEY = 'bai.layout.sidebarCollapsed';
const LS_COPILOT_KEY = 'bai.layout.copilotCollapsed';

function readBool(key: string, defaultValue: boolean): boolean {
  try {
    const stored = localStorage.getItem(key);
    return stored === null ? defaultValue : stored === 'true';
  } catch {
    return defaultValue;
  }
}

/** Layout state for BrightAI feature. Single app-wide instance (providedIn: 'root'). */
@Injectable({
  providedIn: 'root',
})
export class BrightaiLayoutService {
  /** Whether the left client-list sidebar is collapsed. Persisted to localStorage. */
  collapsed = signal<boolean>(readBool(LS_SIDEBAR_KEY, false));

  /** Whether the right BrightAI Copilot panel is collapsed. Defaults to true; persisted to localStorage. */
  copilotCollapsed = signal<boolean>(readBool(LS_COPILOT_KEY, true));

  toggleCollapsed() {
    const next = !this.collapsed();
    this.collapsed.set(next);
    try { localStorage.setItem(LS_SIDEBAR_KEY, String(next)); } catch { /* ignore */ }
  }

  toggleCopilotCollapsed() {
    const next = !this.copilotCollapsed();
    this.copilotCollapsed.set(next);
    try { localStorage.setItem(LS_COPILOT_KEY, String(next)); } catch { /* ignore */ }
  }
}
